// PWA Service Worker - DISABLED
// Jannesmann Baumaschinen
// Service Worker caching caused image display issues
// This version UNREGISTERS any existing service workers and clears all caches

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        // Unregister ALL existing service workers
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
          console.log('[PWA] Service Worker unregistered');
        }
        
        // Clear ALL caches
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
          console.log('[PWA] Cache deleted:', name);
        }
        
        if (registrations.length > 0 || cacheNames.length > 0) {
          console.log('[PWA] All service workers and caches cleared');
        }
      } catch (error) {
        console.log('[PWA] Cleanup error:', error);
      }
    });
  }
}

export async function checkForUpdates() {
  // No-op - service workers disabled
}

export async function clearAllCaches() {
  try {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(name => caches.delete(name)));
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(reg => reg.unregister()));
  } catch (e) {
    // ignore
  }
}
